import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './lang' // 引入配置

import 'element-ui/lib/theme-chalk/index.css';
import "./utils/flexbile"
import '@/styles/index.scss' // global css
import 'vant/lib/index.css';
Vue.config.productionTip = false


new Vue({
  router,
  el:'#app',
  i18n, 
  render: h => h(App)
})